
//Valentine's Offer text direct static replacement

(function () {
  var OLD_TEXTS = [
    "🥳 ¡Nuestra Rebaja de Aniversario está en vivo ahora! 🥳",
    "🥳 ¡La venta de aniversario está en marcha! 🥳",
    "🥳 ¡Nuestras Rebajas de Aniversario están en vivo ahora! 🥳",
    "🌞 ¡La venta de verano está activa! 🌞"

  ];
 // var NEW_TEXT = "❤️ ¡Nuestra Rebaja de San Valentín está en vivo ahora! ❤️";
//  var NEW_TEXT = "Nuestras rebajas de Semana Santa ya están disponibles 🐰🐣";
// var NEW_TEXT = "🕵️ ¡Ya empezó nuestra venta misteriosa de mayo! 🕵️";
// var NEW_TEXT = "🤸🎈 ¡Ya comenzó nuestra venta Play Days! 🎈👩🏼‍🤝‍👨🏽";
  var NEW_TEXT = "🎒✨ ¡Ya comenzó la Oferta Smart Start! ✨📚";

  function replaceText(root) {
    var scope = root || document;

    scope
      .querySelectorAll("h1,h2,h3,h4,h5,h6,#seasonalSale")
      .forEach(function (el) {
        if (OLD_TEXTS.includes(el.textContent.trim())) {
          el.textContent = NEW_TEXT;
        }
      });
  }

  replaceText();

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === "childList" || m.type === "characterData") {
          replaceText(m.target.nodeType === 1 ? m.target : m.target.parentNode);
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();



// (function() {

//   // var NEW_HEADING_TEXT = "🎉 ¡Nuestras Rebajas de Navidad ya están Disponibles! 🥳";
//   // var NEW_HEADING_HTML = '🎉 ¡Nuestras Rebajas de <span class="black-friday-allproducts">Navidad</span> ya están Disponibles! 🥳';

//   var NEW_HEADING_TEXT = "🥳 ¡Nuestra Venta de Aniversario ya está activa! 🥳";
// var NEW_HEADING_HTML = '🥳 ¡Nuestra Venta de <span class="black-friday-allproducts">Aniversario</span> ya está activa! 🥳';


//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;
//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("¡la venta de aniversario está activa") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         lower.includes("¡hoy") &&
//         lower.includes("aniversario") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(/es nuestro\s+aniversario!?/i, "es nuestra Venta de Aniversario!");
//         newText = newText.replace(
//           /es nuestra Venta de Aniversario!/,
//           'es nuestra Venta de <span class="black-friday-allproducts">Aniversario</span>!'
//         );

//         newText = newText.replace(/🎉/g, "🎉").replace(/🥳/g, "🥳");

//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }
//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);
//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();


// (function() {

//   // var NEW_HEADING_TEXT = "🎉 ¡Nuestras Rebajas de Navidad ya están Disponibles! 🥳";
//   // var NEW_HEADING_HTML = '🎉 ¡Nuestras Rebajas de <span class="black-friday-allproducts">Navidad</span> ya están Disponibles! 🥳';

//   var NEW_HEADING_TEXT = "🎄 ¡Nuestras Rebajas de Navidad ya están Disponibles! 🎅";
// var NEW_HEADING_HTML = '🎄 ¡Nuestras Rebajas de <span class="black-friday-allproducts">Navidad</span> ya están Disponibles! 🎅';


//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;
//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("¡la venta de aniversario está activa") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         lower.includes("¡hoy") &&
//         lower.includes("aniversario") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(/es nuestro\s+aniversario!?/i, "es nuestro Navidad Sale!");
//         newText = newText.replace(
//           /es nuestro Navidad Sale!/,
//           'es nuestro <span class="black-friday-allproducts">Navidad</span> Sale!'
//         );

//         newText = newText.replace(/🎉/g, "🎄").replace(/🥳/g, "🎅");

//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }
//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);
//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();

